(function () {
  "use strict";

  var API_BASES = ["https://dev-api.teleadapt.com", "https://api.teleadapt.com"];
  var SITE_KEY = "0x4AAAAAAEDHIc-JmyqtxRyG";
  var TURNSTILE_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var STYLE_ID = "ta-subscribe-page-style";
  var SUCCESS_RESULTS = ["created", "updated", "resubscribed"];
  var turnstilePromise;

  function addStyles() {
    var style;
    if (document.getElementById(STYLE_ID)) return;
    style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      "[data-ta-subscribe-page]{width:100%;font-family:Roboto,Arial,sans-serif;box-sizing:border-box}",
      "[data-ta-subscribe-page] .ta-sp-card{width:100%;max-width:1100px;margin:0;padding:26px 26px 22px;background:#fff;border:1px solid #d1d5db;border-radius:8px;box-sizing:border-box}",
      "[data-ta-subscribe-page] .ta-sp-heading{margin:0 0 8px;color:#111827;font-family:Roboto,Arial,sans-serif;font-size:22px;font-weight:700;line-height:1.3}",
      "[data-ta-subscribe-page] .ta-sp-intro{max-width:760px;margin:0 0 20px;color:#111827;font-size:16px;font-weight:400;line-height:1.5}",
      "[data-ta-subscribe-page] .ta-sp-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px;min-width:0}",
      "[data-ta-subscribe-page] .ta-sp-field{display:flex;min-width:0;flex-direction:column;gap:4px}",
      "[data-ta-subscribe-page] .ta-sp-field--wide{grid-column:1/-1}",
      "[data-ta-subscribe-page] .ta-sp-label{color:#111827;font-size:16px;font-weight:700;line-height:1.35}",
      "[data-ta-subscribe-page] .ta-sp-required{color:#e11d48}",
      "[data-ta-subscribe-page] .ta-sp-input{width:100%;height:40px;min-width:0;padding:10px 8px;border:1px solid #d1d5db;border-radius:4px;background:#fff;color:#111827;font-family:Roboto,Arial,sans-serif;font-size:16px;box-sizing:border-box}",
      "[data-ta-subscribe-page] .ta-sp-input:focus{border-color:#f7941d;outline:0;box-shadow:0 0 0 2px rgba(247,148,29,.18)}",
      "[data-ta-subscribe-page] .ta-sp-input[aria-invalid=true]{border-color:#a55b42;box-shadow:0 0 0 1px rgba(165,91,66,.18)}",
      "[data-ta-subscribe-page] .ta-sp-actions{margin-top:20px;text-align:left}",
      "[data-ta-subscribe-page] .ta-sp-submit{min-height:44px;padding:12px 28px;border:0;border-radius:999px;background:#f7941d;color:#fff;font-family:Roboto,Arial,sans-serif;font-size:16px;font-weight:600;line-height:1.2;cursor:pointer;transition:background-color .2s ease,transform .1s ease}",
      "[data-ta-subscribe-page] .ta-sp-submit:hover{background:#e17f0d}",
      "[data-ta-subscribe-page] .ta-sp-submit:active{background:#c66f09;transform:scale(.97)}",
      "[data-ta-subscribe-page] .ta-sp-submit:disabled{cursor:wait;opacity:.65}",
      "[data-ta-subscribe-page] .ta-sp-status{margin:10px 0 0;color:#111827;font-size:16px;line-height:1.5}",
      "[data-ta-subscribe-page] .ta-sp-status:empty{display:none}",
      "[data-ta-subscribe-page][data-ta-state=error] .ta-sp-status{color:#8a4935}",
      "[data-ta-subscribe-page] .ta-sp-turnstile{max-width:100%;margin-top:10px;overflow-x:auto}",
      "[data-ta-subscribe-page] .ta-sp-turnstile:empty{margin-top:0}",
      "@media(max-width:900px){[data-ta-subscribe-page] .ta-sp-card{padding:24px 22px}}",
      "@media(max-width:760px){[data-ta-subscribe-page] .ta-sp-grid{grid-template-columns:1fr;gap:16px}[data-ta-subscribe-page] .ta-sp-field--wide{grid-column:auto}}",
      "@media(max-width:480px){[data-ta-subscribe-page] .ta-sp-card{padding:20px 16px;border-radius:6px}[data-ta-subscribe-page] .ta-sp-submit{width:100%}}"
    ].join("");
    document.head.appendChild(style);
  }

  function loadTurnstile() {
    var script;
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstilePromise) return turnstilePromise;
    turnstilePromise = new Promise(function (resolve, reject) {
      function loaded() { window.turnstile ? resolve(window.turnstile) : reject(new Error("turnstile_unavailable")); }
      script = document.querySelector('script[src="' + TURNSTILE_URL + '"]');
      if (!script) {
        script = document.createElement("script");
        script.src = TURNSTILE_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener("load", loaded, { once: true });
      script.addEventListener("error", reject, { once: true });
    });
    return turnstilePromise;
  }

  function endpoint(root) {
    var base = String(root.dataset.taApiBase || "https://api.teleadapt.com").replace(/\/$/, "");
    if (API_BASES.indexOf(base) === -1) throw new Error("Subscription service configuration is unavailable.");
    return base + "/api/v1/subscribers";
  }

  function markup() {
    return '<form class="ta-sp-card" data-ta-sp-form novalidate>' +
      '<h2 class="ta-sp-heading">Keep me up to date</h2>' +
      '<p class="ta-sp-intro">Receive product updates, hospitality technology insights and new product announcements from TeleAdapt. You can unsubscribe at any time.</p>' +
      '<div class="ta-sp-grid">' +
        '<label class="ta-sp-field"><span class="ta-sp-label">First Name <span class="ta-sp-required" aria-hidden="true">*</span></span><input class="ta-sp-input" data-ta-sp-field="first_name" autocomplete="given-name" required></label>' +
        '<label class="ta-sp-field"><span class="ta-sp-label">Last Name <span class="ta-sp-required" aria-hidden="true">*</span></span><input class="ta-sp-input" data-ta-sp-field="last_name" autocomplete="family-name" required></label>' +
        '<label class="ta-sp-field ta-sp-field--wide"><span class="ta-sp-label">Email Address <span class="ta-sp-required" aria-hidden="true">*</span></span><input class="ta-sp-input" data-ta-sp-field="email" type="email" autocomplete="email" required></label>' +
        '<label class="ta-sp-field"><span class="ta-sp-label">Company</span><input class="ta-sp-input" data-ta-sp-field="company" autocomplete="organization"></label>' +
        '<label class="ta-sp-field"><span class="ta-sp-label">Title</span><input class="ta-sp-input" data-ta-sp-field="title" autocomplete="organization-title"></label>' +
      '</div>' +
      '<div class="ta-sp-actions"><button class="ta-sp-submit" data-ta-sp-submit type="submit">Subscribe</button></div>' +
      '<p class="ta-sp-status" data-ta-sp-status role="status" aria-live="polite"></p>' +
      '<div class="ta-sp-turnstile" data-ta-sp-turnstile></div>' +
    '</form>';
  }

  function messageFor(result) {
    if (result === "already_pending") return "Please check your inbox to complete your subscription, or try again later.";
    if (result === "cleaned_address") return "This email address cannot currently be subscribed. Please use another address or contact TeleAdapt.";
    if (result === "turnstile_failed") return "Verification failed. Please try again.";
    if (result === "validation_error") return "Please review your details and try again.";
    if (result === "service_unavailable" || result === "upstream_service_error") return "Subscription is temporarily unavailable. Please try again later.";
    return "We could not complete your subscription. Please try again.";
  }

  function initialise(root) {
    var apiEndpoint;
    var form;
    var button;
    var status;
    var turnstileContainer;
    var submitting = false;
    var widgetId = null;
    function control(name) { return root.querySelector('[data-ta-sp-field="' + name + '"]'); }
    function value(name) { return String(control(name).value || "").trim(); }

    if (root.dataset.taSubscribePageInitialised === "true") return;
    try { apiEndpoint = endpoint(root); }
    catch (error) { root.textContent = error.message; return; }
    addStyles();
    root.innerHTML = markup();
    root.dataset.taSubscribePageInitialised = "true";
    root.dataset.taState = "idle";
    form = root.querySelector("[data-ta-sp-form]");
    button = root.querySelector("[data-ta-sp-submit]");
    status = root.querySelector("[data-ta-sp-status]");
    turnstileContainer = root.querySelector("[data-ta-sp-turnstile]");

    function busy(active) {
      submitting = active;
      button.disabled = active;
      form.setAttribute("aria-busy", active ? "true" : "false");
      root.dataset.taState = active ? "submitting" : "idle";
    }

    function validate() {
      var invalid = [];
      ["first_name", "last_name", "email"].forEach(function (name) { control(name).removeAttribute("aria-invalid"); });
      if (!value("first_name")) invalid.push(control("first_name"));
      if (!value("last_name")) invalid.push(control("last_name"));
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value("email"))) invalid.push(control("email"));
      invalid.forEach(function (item) { item.setAttribute("aria-invalid", "true"); });
      if (invalid[0]) invalid[0].focus();
      return invalid.length === 0;
    }

    function recover(message) {
      busy(false);
      root.dataset.taState = "error";
      status.textContent = message;
      if (widgetId !== null && window.turnstile && window.turnstile.remove) {
        try { window.turnstile.remove(widgetId); } catch (_error) { }
      }
      widgetId = null;
      turnstileContainer.replaceChildren();
    }

    function send(token) {
      window.fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: value("email").toLocaleLowerCase(),
          first_name: value("first_name"),
          last_name: value("last_name"),
          company: value("company") || null,
          title: value("title") || null,
          turnstile_token: token,
          marketing_consent: true
        })
      }).then(function (response) {
        return response.json().then(function (body) { return { response: response, body: body }; });
      }).then(function (outcome) {
        if (outcome.response.ok && outcome.body.success === true && SUCCESS_RESULTS.indexOf(outcome.body.result) !== -1) {
          root.dataset.taState = "success";
          status.textContent = "Subscription confirmed. Please wait…";
          window.location.assign("/pages/subscribe-thank-you");
          return;
        }
        recover(messageFor(outcome.body && outcome.body.result));
      }).catch(function () { recover("We could not confirm whether your subscription was received. Please wait before trying again."); });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (submitting) return;
      if (!validate()) { status.textContent = "Please complete the required fields."; return; }
      busy(true);
      status.textContent = "Please wait while we submit your subscription.";
      loadTurnstile().then(function (turnstile) {
        widgetId = turnstile.render(turnstileContainer, {
          sitekey: SITE_KEY,
          theme: "auto",
          callback: send,
          "error-callback": function () { recover("Verification failed. Please try again."); },
          "expired-callback": function () { recover("Verification expired. Please try again."); },
          "timeout-callback": function () { recover("Verification timed out. Please try again."); }
        });
      }).catch(function () { recover("Verification is temporarily unavailable. Please try again."); });
    });
  }

  function initialiseAll() {
    document.querySelectorAll("[data-ta-subscribe-page]").forEach(initialise);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialiseAll, { once: true });
  else initialiseAll();
})();